import './index.css'

const Gallery = () => (
  <div id="Gallery-container">
    <div className="head">
      <h1 className="family-heading">Family</h1>
      <hr className="hr-line-2" />
    </div>
    <div className="Gallery-container-1">
      <div className="img-container">
        <img
          src="https://res.cloudinary.com/dzfzf9c4u/image/upload/v1640446851/f3b8799b-027e-4b9a-a5d6-616f43b9a87a_aqmmxt.jpg"
          alt="grandfather"
          className="Family-images"
        />
        <h1 className="img-head">Pedha Bhimayya Palli</h1>
        <p className="para-head">( Grandfather-Groom )</p>
      </div>
      <div className="img-container">
        <img
          src="https://res.cloudinary.com/dzfzf9c4u/image/upload/v1640449392/fac75879-5188-45b1-8dc6-d5af0306c17c_mjhdap.jpg"
          alt="grandfather"
          className="Family-images"
        />
        <h1 className="img-head">Govinda Rao & Venkata Lakshmi Palli</h1>
        <p className="para-head">( Mom & Dad-Groom )</p>
      </div>
      <div className="img-container">
        <img
          src="https://res.cloudinary.com/dzfzf9c4u/image/upload/v1640450303/DSC00745_hbdvgl.jpg"
          alt="grandfather"
          className="Family-images"
        />
        <h1 className="img-head">Srikanth & Malleswari Nallamolu</h1>
        <p className="para-head">( Mom & Brother-Bride )</p>
      </div>

      <div className="img-container">
        <img
          src="https://res.cloudinary.com/dzfzf9c4u/image/upload/v1640449368/7280ac9d-e81d-41c2-be47-f5c8b789557e_tlrpdd.jpg"
          alt="grandfather"
          className="Family-images"
        />
        <h1 className="img-head">SaiRam & Hema Palli</h1>
        <p className="para-head">( Brother & Trees-Groom )</p>
      </div>
      <div className="img-container">
        <img
          src="https://res.cloudinary.com/dzfzf9c4u/image/upload/v1640449375/29f9e7d8-2dab-4610-84d1-a700291bfba7_gsnshk.jpg"
          alt="grandfather"
          className="Family-images"
        />
        <h1 className="img-head"> Aadhi Palli</h1>
        <p className="para-head">( Brother-Groom )</p>
      </div>
    </div>
  </div>
)

export default Gallery
